import { render, staticRenderFns } from "./TrelloIntegration.vue?vue&type=template&id=41ab2052"
import script from "./TrelloIntegration.vue?vue&type=script&lang=js"
export * from "./TrelloIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports